import React, { Component } from 'react'
// libs
// components
import { OldButton } from 'components/Button'
// redux
import { Push, push } from 'connected-react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
// types
import { Classes } from 'jss'
import { ButtonTypes, ComposeType } from 'types/common'
// styles
import NavBar from 'pages/Guest/NavBar'
import injectSheet from 'react-jss'
import { sheet } from './sheet'

interface Props {
  classes: Classes
  style?: React.CSSProperties
  push?: Push
}

interface State {}

const linksName = [
  { name: 'About Us', to: '/#about' },
  { name: 'Search jobs', to: '/find-jobs' },
  { name: 'Support', to: '/#support' },
  { name: 'FAQ', to: '/#faq' },
  { name: 'Contact information', to: '/#contacts' }
]

class Header extends Component<Props, State> {
  onClick = (path: string, isCandidate: boolean = false) => {
    if (this.props.push) {
      this.props.push({
        pathname: path,
        state: {
          isCandidate
        }
      })
    }
  }

  signUp = () => {
    this.onClick('/sign-up')
  }

  signUpWithParamTrue = () => {
    this.onClick('/sign-up', true)
  }

  getVideoPath = () => {
    const hostname = window.location.hostname

    if (hostname === 'cyber.skilent.com' || hostname === 'cyber.dev.skilent.com') {
      return '/assets/videos/cyber-red-lights.mp4'
    } else if (hostname === 'medical.skilent.com' || hostname === 'medical.dev.skilent.com') {
      return '/assets/videos/medical_bg.mp4'
    } else {
      return window.innerWidth > 767.98
        ? '/assets/videos/3872414-sd.mp4'
        : '/assets/videos/3872414-lowres.mp4'
    }
  }

  render() {
    const { classes } = this.props
    const videoPath = this.getVideoPath()

    return (
      <header className={classes.header}>
        <div className={classes.gradient} />
        <video
          preload="auto"
          autoPlay={true}
          muted={true}
          loop={true}
          id="myVideo"
          className={classes.videoClass}
        >
          <source src={videoPath} type="video/mp4" />
        </video>

        <NavBar />

        <div className={classes.headerTitle}>
          <div className={classes.hero}>
            <h1 className={classes.heroTitle}>
              Skilent is all you need <br /> to find a job or candidates
            </h1>

            <p className={classes.heroSubtitle}>
              Connect talent with opportunity. Whether you're seeking your dream job or the perfect
              candidate, Skilent makes professional connections effortless.
            </p>

            <div className={classes.heroActions}>
              <OldButton
                type={ButtonTypes.DefaultRounded}
                label="find a job"
                onClick={this.signUpWithParamTrue}
              />
              <OldButton
                type={ButtonTypes.PrimaryRounded}
                label="find candidates"
                onClick={this.signUp}
              />
            </div>
          </div>
        </div>
        {/*<div className={classes.bottomHeader}>*/}
        {/*  <div>*/}
        {/*    <div>140+</div>*/}
        {/*    <div>Professional Hiring managers with extensive experience</div>*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <div>500+</div>*/}
        {/*    <div>Verified Recruiters with proper education requirements</div>*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <div>23 000</div>*/}
        {/*    <div>jobs on average are closed every month</div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </header>
    )
  }
}

export default compose<ComposeType<Props>>(
  connect(
    null,
    {
      push
    }
  ),
  injectSheet(sheet)
)(Header)
